export function getBubblesValues(bubbles, value) {

    if (value) {
        const parsedValue = JSON.parse(value)

        let label = ""
        if (parsedValue?.length > 0)
            for (const id of parsedValue) {
                const labelToAppend = bubbles?.find(x => x.value === id)?.label
                if (labelToAppend) label += labelToAppend + " "
            }

        return label.length > 0 ? label : "- -"
    }
}